import { NextLink } from "~/components/blocks/common/next-link";
import type { Links } from "~/components/blocks/vod/top/hooks/use-set-link-data";
import { G_ServicePlan } from "~/lib/graphql";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { useAuth } from "~/provider/auth";

type PcItemsProps = {
  links: Links;
};

export const PcItems = ({ links }: PcItemsProps) => {
  const { isLoggedIn, servicePlan } = useAuth();
  return (
    <>
      {links.map(({ id, name, path }, idx) => (
        <NextLink
          key={name}
          href={path}
          onClick={() =>
            isLoggedIn &&
            servicePlan === G_ServicePlan.Premium &&
            sendTrackingClickCommon({
              clickEventName: "dmmtv_button_category",
              viaTargetId: "dmmtv_" + id,
              viaViewRank: idx + 1,
            })
          }
        >
          {name}
        </NextLink>
      ))}
    </>
  );
};
